import { IAgencyInClientFormData, IClientAdvertiserPayload, IClientAgencyPayload } from '@/Interfaces/Client.interface';
import { IControlOption } from '@/Interfaces/ControlOption.interface';
import ModalHeaderIcon from '@/components/Icons/ModalHeaderIcon';
import LoadingBackdropWrapper from '@/components/Modal/common/LoadingBackdropWrapper';
import ModalTitleCard from '@/components/Modal/common/ModalTitleCard';
import { Button, Dialog, DialogContent } from '@mui/material';
import { useCallback } from 'react';
import { FormProvider, UseFormReturn, useWatch } from 'react-hook-form';
import AgencyInfo from './AgencyInfo';

interface IProps {
  form: UseFormReturn<IAgencyInClientFormData>;
  open: boolean;
  onClose: (agency: IClientAgencyPayload | null) => void;
  loading: boolean;
  openAdvertiserModal: () => void;
  removeControlOption: (value: IControlOption) => void;
}

const AddAgencyModal = ({ form, open, onClose, loading, openAdvertiserModal, removeControlOption }: IProps) => {
  const { control, handleSubmit, reset } = form;

  const newAdvertisers: IClientAdvertiserPayload[] = useWatch({ control, name: 'newAdvertisers' });

  const onSubmit = useCallback(
    async ({ name, advertisers }: IAgencyInClientFormData) => {
      const payload: IClientAgencyPayload = {
        name,
        newAdvertisers,
        advertiserIds: advertisers.map(advertiser => advertiser.value),
        temporaryKey: Date.now(),
      };
      onClose(payload);
      reset();
    },
    [newAdvertisers, onClose, reset],
  );

  const handleClose = useCallback(() => {
    onClose(null);
    reset();
  }, [onClose, reset]);

  return (
    <LoadingBackdropWrapper backdropOpen={loading}>
      <Dialog maxWidth={false} open={open} onClose={handleClose} aria-labelledby='modal-title'>
        <DialogContent sx={{ width: '650px', overflow: 'hidden' }}>
          <ModalTitleCard titleIcon={<ModalHeaderIcon />} handleClose={handleClose} title='Create New Agency' />
          <FormProvider {...form}>
            <form className='mt-4' onSubmit={handleSubmit(onSubmit)}>
              <AgencyInfo openAdvertiserModal={openAdvertiserModal} removeControlOption={removeControlOption} />
              <hr className='-mx-[32px] my-5' />
              <div className='mt-5 flex justify-end gap-[12px]'>
                <Button color='inherit' variant='outlined' onClick={handleClose}>
                  Cancel
                </Button>
                <Button color='primary' variant='contained' type='submit'>
                  Create
                </Button>
              </div>
            </form>
          </FormProvider>
        </DialogContent>
      </Dialog>
    </LoadingBackdropWrapper>
  );
};

export default AddAgencyModal;
